"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEPropertiesCompact = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * AE properties that are used by the individual applications compact requests.
 */
class AEPropertiesCompact {
}
exports.AEPropertiesCompact = AEPropertiesCompact;
_a = echain_shared_igus_fundamentals_1.AppName.TEST, _b = echain_shared_igus_fundamentals_1.AppName.EIQ, _c = echain_shared_igus_fundamentals_1.AppName.EKE, _d = echain_shared_igus_fundamentals_1.AppName.EIC, _e = echain_shared_igus_fundamentals_1.AppName.ECF;
AEPropertiesCompact[_a] = [];
AEPropertiesCompact[_b] = [
    'Id',
    'EchainId',
    'ArtNr',
    'Bezeichnung',
    'Festpunkt',
    'GliedAnzahlAbhaengig',
    'IsStahl',
    'KetteRef',
    'Mitnehmer',
    'Montiert',
    'Variante',
    'ZubehoerRef',
];
AEPropertiesCompact[_c] = [
    'Id',
    'EchainId',
    'ArtNr',
    'Ausfuehrung',
    'Ausrichtung',
    'Befestigungsvariante',
    'Bezeichnung',
    'CProfilPosition',
    'Einbauart',
    'Festpunkt',
    'Gewicht',
    'GliedAnzahlAbhaengig',
    'HasCProfil',
    'HasKamm',
    'IsKMA',
    'IsStahl',
    'KetteRef',
    'Komplettsatz',
    'Laenge',
    'Mitnehmer',
    'Montiert',
    'Standard',
    'Typ',
    'Variante',
    'WidenBildId',
    'WidenZeichnungId',
    'ZubehoerRef',
];
AEPropertiesCompact[_d] = ['EchainId'];
AEPropertiesCompact[_e] = ['EchainId'];
//# sourceMappingURL=AEPropertiesCompact.js.map